import React from "react";
import { Row, Col } from "reactstrap";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";

const CustomTextField = styled((props) => <TextField {...props} />)(
  ({ theme, ownerState }) => ({
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: ownerState.color,
      },
      "&:hover fieldset": {
        borderColor: ownerState.color,
      },
      "&.Mui-focused fieldset": {
        borderColor: ownerState.color,
      },
    },
    "& .MuiInputBase-input": {
      color: ownerState.darkMode ? "#ffffff" : "#000000",
      paddingTop: "10px",
    },
    "& .MuiInputLabel-root": {
      color: ownerState.darkMode ? "#ffffff" : "#000000",
    },
  })
);

const SpecialInstructions = ({ selectedItem, setSelectedItem }) => {
  const { color, darkMode } = useSelector((state) => state.global);

  const handleNoteChange = (e) => {
    setSelectedItem((prev) => ({
      ...prev,
      notes: e.target.value,
    }));
  };

  return (
    <Row className="mx-2 mt-4">
      <Col xs={12}>
        <CustomTextField
          label="Special instructions"
          fullWidth
          multiline
          rows={3}
          placeholder="Any special requests for this item..."
          name="notes"
          value={selectedItem.notes}
          onChange={handleNoteChange}
          variant="outlined"
          ownerState={{ darkMode, color }}
        />
      </Col>
    </Row>
  );
};

export default SpecialInstructions;
